import React, { useState } from 'react';
import './VPSGermany.css';

const VPSGermany = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'استارتر',
      price: '۲۹۰',
      unit: 'هزار تومان / ماه',
      cpu: '2 Core',
      ram: '۴ GB',
      storage: '۵۰ GB NVMe',
      features: ['لوکیشن آلمان', 'پایداری بالا', 'امنیت عالی', 'پشتیبانی ۲۴/۷'],
      popular: false,
    },
    {
      tier: 'پیشرفته',
      price: '۴۹۰',
      unit: 'هزار تومان / ماه',
      cpu: '4 Core',
      ram: '۸ GB',
      storage: '۱۰۰ GB NVMe',
      features: ['لوکیشن آلمان', 'پایداری بالا', 'امنیت عالی', 'پشتیبانی ۲۴/۷', 'IP اختصاصی'],
      popular: true,
    },
    {
      tier: 'حرفه‌ای',
      price: '۷۹۰',
      unit: 'هزار تومان / ماه',
      cpu: '8 Core',
      ram: '۱۶ GB',
      storage: '۲۰۰ GB NVMe',
      features: ['لوکیشن آلمان', 'پایداری بالا', 'امنیت عالی', 'پشتیبانی ۲۴/۷', 'IP اختصاصی', 'اولویت پشتیبانی'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '🇩🇪',
      title: 'دیتاسنترهای معتبر آلمان',
      desc: 'VPS آلمان در بهترین دیتاسنترهای آلمان با استانداردهای امنیتی بالا و زیرساخت‌های پیشرفته قرار دارد. آلمان به عنوان یکی از امن‌ترین کشورها برای میزبانی داده شناخته می‌شود.',
    },
    {
      icon: '⚡',
      title: 'پایداری و آپتایم بالا',
      desc: 'دیتاسنترهای آلمان با سیستم‌های پشتیبانی پیشرفته و برق اضطراری، پایداری و آپتایم فوق‌العاده‌ای را برای سرور شما فراهم می‌کنند. مناسب برای پروژه‌های حیاتی.',
    },
    {
      icon: '🛡️',
      title: 'امنیت و حریم خصوصی بالا',
      desc: 'آلمان با قوانین سختگیرانه حریم خصوصی و امنیت داده، یکی از بهترین کشورها برای میزبانی وب است. VPS آلمان امنیت و حریم خصوصی داده‌های شما را تضمین می‌کند.',
    },
    {
      icon: '🌍',
      title: 'دسترسی عالی به شبکه‌های جهانی',
      desc: 'VPS آلمان با اتصال به شبکه‌های جهانی و پهنای باند بالا، دسترسی عالی به کاربران در سراسر جهان را فراهم می‌کند.',
    },
  ];

  const faqs = [
    {
      q: 'VPS آلمان چه مزایایی نسبت به سایر لوکیشن‌های اروپایی دارد؟',
      a: 'آلمان به عنوان قلب اقتصادی اروپا، دارای دیتاسنترهای بسیار پیشرفته با استانداردهای امنیتی بالا است. قوانین حریم خصوصی در آلمان بسیار سختگیرانه است و داده‌های شما به خوبی محافظت می‌شود. همچنین پینگ VPS آلمان برای کاربران ایرانی و خاورمیانه بسیار عالی است و سرعت بارگذاری فوق‌العاده‌ای را فراهم می‌کند.',
    },
    {
      q: 'آیا VPS آلمان برای فروشگاه‌های آنلاین مناسب است؟',
      a: 'بله، VPS آلمان با پایداری بالا و سرعت عالی، گزینه‌ای ایده‌آل برای فروشگاه‌های آنلاین است. پهنای باند بالا و امنیت عالی، تجربه خرید بی‌نظیری را برای مشتریان شما فراهم می‌کند. همچنین موقعیت استراتژیک آلمان در مرکز اروپا، دسترسی عالی به بازارهای اروپایی را ممکن می‌سازد.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>VPS آلمان | خرید سرور مجازی آلمان با بهترین قیمت | افرسل</h1>
        <p>خرید VPS آلمان با دیتاسنترهای معتبر، پایداری بالا و پشتیبانی ۲۴ ساعته. سرور مجازی آلمان مناسب برای وب‌سایت‌های اروپایی، فروشگاه‌های آنلاین و پروژه‌های سازمانی.</p>
        <meta name="description" content="خرید VPS آلمان با بهترین قیمت از افرسل. سرور مجازی آلمان با دیتاسنتر معتبر، پایداری بالا، امنیت عالی و پشتیبانی ۲۴/۷." />
      </div>

      <section className="vps-germany-hero">
        <div className="vps-germany-hero-bg"></div>
        <div className="wrap">
          <div className="vps-germany-hero-content">
            <div className="vps-germany-badge">
              <span className="pulse-dot"></span>
              🇩🇪 VPS آلمان
            </div>
            <h1 className="vps-germany-hero-title">
              سرور مجازی <em>آلمان</em>
            </h1>
            <p className="vps-germany-hero-desc">
              VPS آلمان با دیتاسنترهای معتبر، پایداری بالا و امنیت عالی.
              مناسب برای وب‌سایت‌های اروپایی، فروشگاه‌های آنلاین و پروژه‌های سازمانی.
            </p>
            <div className="vps-germany-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">آلمان</span>
                <span className="stat-label">لوکیشن</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vps-germany-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های VPS آلمان</span>
            <h2 className="sec-h">پلن <em>مناسب</em> پروژه خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع VPS آلمان با قیمت‌های رقابتی و منابع کافی برای هر نوع پروژه.</p>
          </div>
          <div className="vps-germany-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`vps-germany-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="vps-germany-popular-badge">پرفروش‌ترین</span>}
                <div className="vps-germany-plan-tier">{plan.tier}</div>
                <div className="vps-germany-plan-price">
                  <span className="vps-germany-plan-num">{plan.price}</span>
                  <span className="vps-germany-plan-unit">{plan.unit}</span>
                </div>
                <div className="vps-germany-plan-specs">
                  <div><span>🖥️</span> {plan.cpu}</div>
                  <div><span>💾</span> {plan.ram}</div>
                  <div><span>📀</span> {plan.storage}</div>
                </div>
                <ul className="vps-germany-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="vps-germany-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-germany-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای VPS آلمان</span>
            <h2 className="sec-h">چرا <em>VPS آلمان</em> با افرسل؟</h2>
            <p className="sec-p">VPS آلمان با بهترین امکانات و خدمات برای کسب‌وکارهای اروپایی و بین‌المللی.</p>
          </div>
          <div className="vps-germany-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="vps-germany-feature-card">
                <span className="vps-germany-feature-icon">{feature.icon}</span>
                <h3 className="vps-germany-feature-title">{feature.title}</h3>
                <p className="vps-germany-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-germany-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="vps-germany-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="vps-germany-faq-item">
                <div className="vps-germany-faq-q">{faq.q}</div>
                <div className="vps-germany-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-germany-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              VPS <em>آلمان</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید VPS آلمان، از پایداری بالا، امنیت عالی و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید VPS</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VPSGermany;
